import { isNullOrEmpty } from "functions/extensions/StringExtensions";
import { toDoubleDigitString } from "functions/converters/NumberConverters";

// Documentation: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
const beDateFormat = new Intl.DateTimeFormat('nl-BE', { day: '2-digit', month: '2-digit', year: 'numeric' });
const userLocalFormat = new Intl.DateTimeFormat(navigator.language, { day: '2-digit', month: '2-digit', year: 'numeric' });
// Test
// const userLocalFormat = new Intl.DateTimeFormat('ko', { day: '2-digit', month: '2-digit', year: 'numeric' });

export function toDateString(date: string | undefined, undefinedAllowed?: boolean): string | undefined;
export function toDateString(date: string | undefined, undefinedAllowed = false)
{
    if (!isNullOrEmpty(date as string)) {
        // console.log(date)
        if ((date as string).startsWith('0')) {
            return undefinedReturnCallString(date as string, undefinedAllowed);
        }
        return userLocalFormat.format(new Date(date as string));
    } else {
        return undefinedReturnCallString(date as string, undefinedAllowed);
    }
}

export function toDateStringBE(date: string | undefined, undefinedAllowed = false)
{
    if (!isNullOrEmpty(date)) {
        // Because empty dates that are returned from the server start with 0
        if ((date as string).startsWith('0')) {
            return undefinedReturnCallString(date, undefinedAllowed);
        }
        return beDateFormat.format(new Date(date as string));
    } else {
        return undefinedReturnCallString(date, undefinedAllowed);
    }
}

export function toYearAndMonthDateBE(date: string | undefined, undefinedAllowed = false)
{
    if (!isNullOrEmpty(date)) {
        if ((date as string).startsWith('0')) {
            return undefinedReturnCallString(date, undefinedAllowed);
        }
        const d = new Date(date as string);
        return d.getFullYear() + '/' + toDoubleDigitMonth(d.getMonth() + 1);
        // return yearMonthDateFormat.format(new Date(dateString as string));
    } else {
        return undefinedReturnCallString(date, undefinedAllowed);
    }
}

function toDoubleDigitMonth(month: number): string
{
    if (month < 10) return '0' + month.toString();
    return month.toString();
}

// function undefinedReturnCallDate(value: Date | undefined, undefinedAllowed: boolean)
// {
//     return undefinedAllowed ? undefinedAllowed : '';
// }

function undefinedReturnCallString(value: string | undefined, undefinedAllowed: boolean)
{
    return undefinedAllowed ? undefined : '';
}

/**
 * Returns date as "yyyy-mm-dd"
 */
export function formatDateToQueryDate(date: Date)
{
    return date.getFullYear().toString() + '-' + toDoubleDigitString(date.getMonth() + 1) + '-' + toDoubleDigitString(date.getDate());
}